import type { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { CustomTable } from 'components/table/style';
import { Badge, Button, Spinner, Table, Typography, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { AddItemModal } from 'modules/dashboard/components/AddItemModal';
import { AddButton } from 'modules/dashboard/styles/functional-test';
import type { Learner } from 'modules/learners/core/type';

import { CustomCreateButton, Group } from '../styles/member';

import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/circle-close.svg';

import { isEmpty } from 'lodash';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { CreateLearnModal } from './CreateLearnModal';

export const LearnersComp: FC<{
  learnerColumns: any[];
  learners: Learner[];
  totalLearner: number;
  listLearner: Learner[];
  membersColumns: any[];
  handleUpdateMembers: (type: 'trainer' | 'learner') => void;
  searchLearner: string;
  onChangeSearchLearner: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddGroup: () => void;
  groupLearners: { group: string; learners: Learner[]; id: string; index: number }[];
  hasMore: boolean;
  handleDeleteGroup: (groupId: string) => void;
  showNoDataLearner: boolean;
  handleLoadMoreLearner: () => void;
}> = ({
  learnerColumns,
  learners,
  totalLearner,
  listLearner,
  membersColumns,
  handleUpdateMembers,
  searchLearner,
  onChangeSearchLearner,
  handleAddGroup,
  groupLearners,
  handleDeleteGroup,
  showNoDataLearner,
  handleLoadMoreLearner,
  hasMore,
}) => {
  return (
    <div style={{ marginTop: 64 }}>
      <CustomTable>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px 16px',
            margin: '0 -16px',
            borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
              Learners
            </Typography>

            <Badge
              bg={COLOR_CONFIG['neutral-text']}
              color="#ffffff"
              count={totalLearner}
              style={{ fontWeight: 600, fontSize: 12, lineHeight: '16px' }}
            />
          </div>

          <AddItemModal
            title={'Add client'}
            extraDropdownContentStyle={{ position: 'absolute', right: '4rem', bottom: '-22rem' }}
            options={listLearner}
            onAdd={() => handleUpdateMembers('learner')}
            placeholderSearch="Search by name or phone"
            searchValue={searchLearner}
            onChange={onChangeSearchLearner}
            content={
              <div style={{ height: '100%', overflow: 'auto' }}>
                <InfiniteScroll
                  pageStart={1}
                  loadMore={handleLoadMoreLearner}
                  hasMore={hasMore}
                  loader={
                    hasMore ? (
                      <div style={{ color: '#262626', textAlign: 'center' }} key={0}>
                        <Spinner style={{ margin: '8px 0' }} size={'md'} />
                      </div>
                    ) : undefined
                  }
                  useWindow={false}
                >
                  <Table
                    columns={membersColumns}
                    dataSource={listLearner}
                    total={99999}
                    tableKey={''}
                    queryState={{
                      page: 1,
                      limit: 99999,
                    }}
                    paginationConfigs={{
                      show: false,
                    }}
                    headerConfigs={{
                      show: false,
                    }}
                  />
                </InfiniteScroll>
              </div>
            }
            createButton={
              <CustomCreateButton>
                <Button
                  icon={<AddIcon style={{ marginRight: 4, width: 20, height: 20 }} />}
                  placementIcon="left"
                  onClick={() => openModal(MODAL_KEY.CREATE_LEARNER)}
                >
                  Create a new Learner
                </Button>
              </CustomCreateButton>
            }
          />
        </div>
        {showNoDataLearner ? (
          <Typography
            variant="h4"
            weight={600}
            style={{
              textAlign: 'center',
              justifyContent: 'center',
              marginTop: 16,
              marginBottom: 40,
            }}
          >
            No data
          </Typography>
        ) : (
          groupLearners.map((el, index) => {
            const isLastItemOfLastGroup = index === groupLearners.length - 1;

            return (
              <Group key={el.group} style={isLastItemOfLastGroup ? { borderBottom: 'none' } : {}}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
                  }}
                >
                  <div style={{ display: 'flex', gap: 10 }}>
                    <Typography
                      style={{ marginBottom: 12 }}
                      variant="body-2"
                      weight={600}
                      color={COLOR.surfaceNeutralBold['neutral-11']}
                    >
                      {el.group}
                    </Typography>
                    {el.group !== 'No group' && (
                      <DeleteIcon
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteGroup(el.id)}
                      />
                    )}
                  </div>
                  {el.learners.length === 4 && el.id && (
                    <Typography style={{ fontSize: '16px', lineHeight: '22px', color: '#808080' }}>
                      Reached the maximum of 4 slots
                    </Typography>
                  )}
                </div>
                {isEmpty(el.learners) ? (
                  <div style={{ padding: '12px 8px' }}>
                    <Typography
                      style={{
                        fontSize: 18,
                        lineHeight: '26px',
                        color: COLOR_CONFIG['neutral-text'],
                      }}
                    >
                      There is no client in this group.
                    </Typography>
                  </div>
                ) : (
                  <Table
                    columns={learnerColumns}
                    dataSource={el.learners}
                    total={99999}
                    tableKey={''}
                    queryState={{ page: 1, limit: 99999 }}
                    paginationConfigs={{
                      show: false,
                    }}
                  />
                )}
              </Group>
            );
          })
        )}

        <AddButton onClick={handleAddGroup}>
          <AddIcon style={{ width: 20, height: 20 }} />
          <Typography weight={600} style={{ fontSize: 18, lineHeight: '26px' }}>
            Add group
          </Typography>
        </AddButton>
      </CustomTable>

      <CreateLearnModal />
    </div>
  );
};
